import { useEffect, useState } from 'react';
import { Divider, Space, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { convertDateTime } from 'utils';

interface DataType {
  key: string | number;
  datetime: string;
  activityDescription: string;
}

const ActivityHistoryTab = ({ data }: any) => {
  const [loadingTable, setLoadingTable] = useState(false);
  const [dataTable, setDataTable] = useState([]);

  const columns: ColumnsType<DataType> = [
    {
      title: 'Date time',
      dataIndex: 'datetime',
      key: 'datetime',
    },
    {
      title: 'Activity Description',
      dataIndex: 'activityDescription',
      key: 'activityDescription',
    },
  ];

  const formatDataTable = (source: any) => {
    setLoadingTable(true);
    const data = source.sort((a: any, b: any) => (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any)).map((item: any) => {
      return ({
        key: item._id,
        activityDescription: item.description,
        datetime: convertDateTime(item.createdAt),
      })
    })

    setDataTable(() => {
      setLoadingTable(false);
      return data;
    });
  };

  useEffect(() => {
    formatDataTable(data.activity_history);
  }, [])

  return (
    <div>
      <Space direction="vertical" size="large" style={{ width: "100%", padding: 20 }}>
        <Divider orientation="left">
          <Typography.Title level={3}>Activity History</Typography.Title>
        </Divider>
        <Table
          loading={loadingTable}
          className="table-striped-row"
          columns={columns}
          dataSource={dataTable}
          pagination={false}
        />
      </Space>
    </div>
  );
};

export default ActivityHistoryTab;